@if (loading) {
  <app-loader></app-loader>
}
<div class="row mb-3">
  <div class="col-12 col-lg-6">
    <app-dynamic-breadcrumb [bgColor]="'transparent'" [fontSize]="'14px'"
    [lastLinkColor]="'rgba(196, 196, 205, 0.42)'" [fontColor]="'#c4c4cd'"></app-dynamic-breadcrumb>
  </div>
</div>

@if (ingestionModel) {
  <div class="row">
    <div class="col-6">
      <div class="row header">Ingestion Details</div>
      <form #ingestionForm="ngForm">
        <div class="row form-row">
          <div class="col-4"><label>Ingestion Type</label></div>
          <div class="col-8">
            <select (change)="onTemplateTypeChange($event.target.value)" id="templateTypeId"
              name="templateTypeId" [(ngModel)]="selectedTemplateTypeId"
              class="ingestion-form-control w-100 select-arrow">
              @for (type of templateTypes; track type) {
                <option
                  value={{type.value}}>
                  {{type.name}}
                </option>
              }
            </select>
          </div>
        </div>
        <div class="row form-row">
          <div class="col-4"><label>Template Type</label></div>
          <div class="col-8">
            <select (change)="onTemplateGroupChange($event.target.value)" id="templateGroup"
              name="templateGroup" [(ngModel)]="selectedTemplateGroupId"
              class="ingestion-form-control w-100 select-arrow">
              @for (group of templateGroups; track group) {
                <option [selected]="group.value == selectedTemplateGroupId"
                  value={{group.value}}>
                  {{group.name}}
                </option>
              }
            </select>
          </div>
        </div>
        <div class="row form-row">
          <div class="col-4"><label>Template</label></div>
          <div class="col-8">
            <select (change)="onTemplateChange($event.target.value)" id="templateType" name="templateType"
              [(ngModel)]="selectedTemplateId" class="ingestion-form-control w-100 select-arrow">
              @for (type of  templates; track type) {
                <option [selected]="type.value == selectedTemplateId"
                  value={{type.value}}>
                  {{type.name}}
                </option>
              }
            </select>
            @if (!newReportPack && selectedReportPack != null && selectedTemplate != null && !selectedTemplate.showFileUpload && selectedReportPack.DataTypes.indexOf(selectedTemplate.tableId) > -1) {
              <div
                class="row alert alert-danger">
                <div>
                  The selected report pack already contains data for {{selectedTemplate.name}}. Please edit
                  the
                  existing form for changing data.
                </div>
              </div>
            }
            @if (selectedTemplateGroupId != 9 && selectedTemplateGroupId != 10 && !newReportPack && selectedReportPack != null && selectedTemplate != null && selectedTemplate.showFileUpload && selectedReportPack.DataTypes.indexOf(selectedTemplate.tableId) > -1) {
              <div
                class="row alert alert-danger">
                <div>
                  The selected report pack already contains a load in draft status for
                  {{selectedTemplate.name}}. Please submit the existing draft load or abandon the previous
                  draft load using the 'Abandon Previous Draft Load' button below, before a new upload.
                </div>
              </div>
            }
          </div>
        </div>
        <div class="row form-row">
          <div class="col-4"><label>Create New Report Pack ?</label></div>
          <div class="col-8">
            <kendo-switch name="newReportPackSelection" [(ngModel)]="newReportPack" onLabel="Yes" offLabel="No"
              (valueChange)="onNewReportPackSelectionChange($event)" [disabled]="isNewReportPackSwitchDisabled">
            </kendo-switch>
          </div>
        </div>
        @if (newReportPack) {
          <div class="row form-row">
            <div class="col-4"><label>Report Pack Title</label></div>
            <div class="col-8">
              <input type="text" required maxlength="50" minlength="4"
                [(ngModel)]="ingestionModel.reportpacktitle" class="ingestion-form-control"
                #reportpackttl="ngModel" id="reportpacktitle" name="reportpacktitle"
                pattern="^[A-Za-z0-9 _\-.]*$" trim-text>
                @if (reportpackttl.invalid && (reportpackttl.dirty || reportpackttl.touched)) {
                  <div
                    class="alert alert-danger">
                    @if (reportpackttl.errors.required) {
                      <div>
                        Report pack title is a mandatory field.
                      </div>
                    }
                    @if (reportpackttl.errors.pattern) {
                      <div>
                        Report pack title is not valid, as it contains special characters.
                      </div>
                    }
                    @if (reportpackttl.errors.minlength) {
                      <div>
                        Report pack title must be at least 4 characters long.
                      </div>
                    }
                    @if (reportpackttl.errors.maxlength) {
                      <div>
                        Report pack title should not exceed 50 characters.
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
          @if (newReportPack) {
            <div class="row form-row">
              <div class="col-4"><label>Report Pack Description</label></div>
              <div class="col-8">
                <textarea class="ingestion-form-control" [(ngModel)]="ingestionModel.reportpackdesc" maxlength="150"
                  name="reportpackDescription" #reportpackdsc="ngModel" pattern="[^^/:*|'<>\\{}\[\]]*"
                id="reportpackdesc" trim-text></textarea>
                @if (reportpackdsc.invalid && (reportpackdsc.dirty || reportpackdsc.touched)) {
                  <div
                    class="alert alert-danger">
                    @if (reportpackdsc.errors.pattern) {
                      <div>
                        The report pack description is not valid, as it contains special
                        characters.
                      </div>
                    }
                    @if (reportpackdsc.errors.maxlength) {
                      <div>
                        Report pack description should not exceed 150 characters.
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
          @if (!newReportPack) {
            <div class="row form-row">
              <div class="col-4"><label>Report Pack </label></div>
              <div class="col-8">
                <app-report-pack-filter [(selectedReportPacks)]="selectedReportPack"
                  [showOnlyValidReportPacks]="false" [selectedRpIds]="ingestionModel.reportpackid"
                  [updateServiceOnRpSelection]="false"
                  (selectedReportPacksChange)="onExistingReportPackSelection()">
                </app-report-pack-filter>
                @if (dataPrepInProgress) {
                  <h6 class="text-white-50 font-italic small-font mt-3">
                    <i class="fas fa-exclamation-triangle hvr-shrink failed-icon mr-3"></i>Data preparation is in
                    progress for
                    the report pack. Please initiate ingestion after data preparation is complete for the report
                    pack!
                  </h6>
                }
              </div>
            </div>
          }
          @if (((newReportPack || ingestionModel.rpHasNullReportingDate) && selectedTemplate && selectedTemplate.reportDateMandatory)) {
            <div class="row form-row"
              >
              <div class="col-4"><label>Reporting Date</label></div>
              <div class="col-8">
                <p-datepicker required [(ngModel)]="ingestionModel.reportingperiod" [showIcon]="true"
                  [autoZIndex]="true" id="reportingdatecalendar" name="reportingdatecalendar"
                  dateFormat="dd/mm/yy" [readonlyInput]="true" [monthNavigator]="true" yearRange="{{yearRange}}"
                  [yearNavigator]="true" [utc]="true" (onSelect)="onDateSelect($event)"
                  styleClass="w-100" inputStyleClass="ingestion-form-control" placeholder="Select Date">
                </p-datepicker>
                @if (newReportPack && selectedTemplate.reportDateMandatory && (!ingestionModel.reportingperiod || ingestionModel.reportingperiod === undefined)) {
                  <div
                    class="alert alert-danger">
                    Reporting date is a mandatory field.
                  </div>
                }
              </div>
            </div>
          }
          @if (newReportPack) {
            <div class="row form-row">
              <div class="col-4"><label>Accounting Framework</label></div>
              <div class="col-8">
                <select id="accountingFramework" name="accountingFramework"
                  [(ngModel)]="ingestionModel.accountingFrameworkId"
                  class="ingestion-form-control w-100 select-arrow">
                  @for (af of  accountingFrameworks; track af) {
                    <option
                      [selected]="af.AccountingFrameworkId == ingestionModel.accountingFrameworkId"
                      value={{af.AccountingFrameworkId}}>
                      {{af.AccountingFrameworkName}}
                    </option>
                  }
                </select>
              </div>
            </div>
          }
          @if (newReportPack) {
            <div class="row form-row">
              <div class="col-4"><label>Reporting Level</label></div>
              <div class="col-8">
                <select id="reportingLevel" name="reportingLevel" [(ngModel)]="ingestionModel.reportingLevelId"
                  class="ingestion-form-control w-100 select-arrow">
                  @for (rl of  reportingLevels; track rl) {
                    <option
                      [selected]="rl.ReportingLevelId == ingestionModel.reportingLevelId"
                      value={{rl.ReportingLevelId}}>
                      {{rl.ReportingLevelName}}
                    </option>
                  }
                </select>
              </div>
            </div>
          }
          @if (newReportPack) {
            <div class="row form-row">
              <div class="col-4"><label>Create New Report Pack Sequence ?</label></div>
              <div class="col-8">
                <kendo-switch name="newReportPackSequenceSelection" [(ngModel)]="newReportPackSequence"
                  onLabel="Yes" offLabel="No" (valueChange)="onRPSequenceSelectionChange($event)">
                </kendo-switch>
              </div>
            </div>
          }
          @if (newReportPack && newReportPackSequence) {
            <div class="row form-row">
              <div class="col-4"><label>Report Pack Sequence Name</label></div>
              <div class="col-8">
                <input type="text" required maxlength="50" minlength="4"
                  [(ngModel)]="ingestionModel.reportPackSequenceName" class="ingestion-form-control"
                  #reportPackSequenceName="ngModel" id="reportPackSequenceName" name="reportPackSequenceName"
                  pattern="^[A-Za-z0-9 _\-.]*$" trim-text>
                  @if (reportPackSequenceName.invalid && (reportPackSequenceName.dirty || reportPackSequenceName.touched)) {
                    <div
                      class="alert alert-danger">
                      @if (reportPackSequenceName.errors.required) {
                        <div>
                          Report pack sequence title is a mandatory field.
                        </div>
                      }
                      @if (reportPackSequenceName.errors.pattern) {
                        <div>
                          Report pack sequence title is not valid, as it contains special characters.
                        </div>
                      }
                      @if (reportPackSequenceName.errors.minlength) {
                        <div>
                          Report pack sequence title must be at least 4 characters long.
                        </div>
                      }
                      @if (reportPackSequenceName.errors.maxlength) {
                        <div>
                          Report pack sequence title should not exceed 50 characters.
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
            @if (newReportPack && newReportPackSequence) {
              <div class="row form-row">
                <div class="col-4"><label>Report Pack Sequence Description</label></div>
                <div class="col-8">
                  <textarea class="ingestion-form-control" [(ngModel)]="ingestionModel.reportPackSequenceDescription"
                    maxlength="150" name="reportPackSequenceDescription" #reportPackSequenceDescription="ngModel"
                  pattern="[^^/:*|'<>\\{}\[\]]*" id="reportPackSequenceDescription" trim-text></textarea>
                  @if (reportPackSequenceDescription.invalid && (reportPackSequenceDescription.dirty || reportPackSequenceDescription.touched)) {
                    <div
                      class="alert alert-danger">
                      @if (reportPackSequenceDescription.errors.pattern) {
                        <div>
                          The report pack sequence description is not valid, as it contains special
                          characters.
                        </div>
                      }
                      @if (reportPackSequenceDescription.errors.maxlength) {
                        <div>
                          Report pack sequence description should not exceed 150 characters.
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
            @if (newReportPack && !newReportPackSequence) {
              <div class="row form-row">
                <div class="col-4"><label>Report Pack Sequence</label></div>
                <div class="col-8">
                  <app-report-pack-sequence-filter [(selectedRpSequences)]="selectedReportPackSequence"
                    [selectedRpSequenceIds]="ingestionModel.reportPackSequenceId"
                    (selectedRpSequencesChange)="onExistingRPSequenceSelection()">
                  </app-report-pack-sequence-filter>
                </div>
              </div>
            }
            @if (!newReportPack) {
              <div class="row form-row">
                <div class="col-4"> <label>Change Reason</label></div>
                <div class="col-8">
                  <textarea class="ingestion-form-control" [(ngModel)]="ingestionModel.changereason" maxlength="150"
                    required name="changeReason" #rpChangeReason="ngModel" pattern="[^^/:*|'<>\\{}\[\]]*"
                  id="rpChangeReason" trim-text></textarea>
                  @if (rpChangeReason.invalid && (rpChangeReason.dirty || rpChangeReason.touched)) {
                    <div
                      class="alert alert-danger">
                      @if (rpChangeReason.errors.required) {
                        <div>
                          Change reason is a mandatory field.
                        </div>
                      }
                      @if (rpChangeReason.errors.pattern) {
                        <div>
                          The change reason is not valid, as it contains special characters.
                        </div>
                      }
                      @if (rpChangeReason.errors.maxlength) {
                        <div>
                          Change Reason should not exceed 150 characters.
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
            <!-- <div class="w-100 justify-content-center info-message" *ngIf="showFileUploadSection">
            Please upload a file of size upto 35 MB.
          </div> -->
          @if (showFileUploadSection) {
            <div class="files mb-0 w-100">
              <input type="file" class="ingestion-form-control" name="fileUpload"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                (change)="handleFileInput($event.target.files)">
                @if (showFileDetail == false) {
                  <p class="file-upload-text">
                    Click in this area
                    to upload a file.
                  </p>
                }
                @if (showFileDetail == true) {
                  <div
                    class="file-upload-text d-flex flex-column align-items-center justify-content-center">
                    <i class="far fa-file-excel text-success fa-2x mb-3"></i>
                    <h5 class="text-center text-break w-75">{{ingestionModel.fileName}}</h5>
                  </div>
                }
              </div>
            }
          </form>
        </div>
        <div class="col-6">
          <div class="row header" style="margin-left:1px">Report Run</div>
          <app-report-tree [(selectedReports)]="selectedReports" selectDependencies="true"></app-report-tree>
        </div>
        <div class="alignButtons m-0 d-md-block mt-3">
          <button class="btn btn-modal-neg small-font mr-2 hvr-shrink" type="button" (click)='backToIngestion()'>
            <span>Back to Ingestion</span>
          </button>
          <button class="btn btn-modal-neg small-font mr-2 hvr-shrink" type="button" (click)='clear()'>
            <span>Clear</span>
          </button>
          @if (selectedTemplateGroupId != 9 && selectedTemplateGroupId != 10 && !newReportPack && selectedReportPack != null && selectedTemplate != null && selectedTemplate.showFileUpload && selectedReportPack.DataTypes.indexOf(selectedTemplate.tableId) > -1) {
            <button class="btn btn-modal-pos small-font hvr-shrink" type="button" (click)="onAbandonPreviousLoad()"
              >
              <span>Abandon Previous Draft Load</span>
            </button>
          }
          <button class="btn btn-modal-pos small-font hvr-shrink" type="button" (click)="onStartIngestion()"
            [disabled]="ingestionForm && ingestionForm.form ? !ingestionForm.form.valid : false">
            <span>Start Ingestion</span>
          </button>
        </div>
      </div>
    }